import React, { useRef } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../components/Loaders/Spinner';
import Alert from '../../../../components/Alert';

const ReportPaymentModal = ({ open, error, isLoading, onHide, onSubmit }) => {
  const formNode = useRef(null);

  const onSubmitForm = () => {
    const current = formNode?.current;
    const formData = {
      comment: current?.comment?.value,
    };
    onSubmit?.(formData, 'report');
  };

  return (
    <Modal show={open} onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Report a fraud</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert text={error} />}

        <form ref={formNode} onSubmit={onSubmitForm}>
          <FormGroup>
            <ControlLabel>Comment</ControlLabel>
            <FormControl componentClass="textarea" rows={6} name="comment" />
          </FormGroup>
        </form>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" type="submit" disabled={isLoading} onClick={onSubmitForm}>
          {isLoading && <Spinner />}
          <span>Report</span>
        </Button>
        <Button
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ReportPaymentModal.propTypes = {
  open: PropTypes.bool,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ReportPaymentModal;
